import { OrderType } from '@exam-center/graphql';
import { type dataGridSortDirection } from '@shared/components';

type DataGridSortDirection = (typeof dataGridSortDirection)[number];

export const ORDER_TYPE: Record<DataGridSortDirection, OrderType> = {
  asc: OrderType.Asc,
  desc: OrderType.Desc,
};
